import { Component, type ReactNode, type ErrorInfo } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6" style={{ backgroundColor: 'var(--color-background)', color: 'var(--color-foreground)' }}>
          <div className="max-w-lg w-full text-center font-mono">
            <div className="text-accent text-sm mb-4">[ ERROR ]</div>
            <h1 className="text-lg font-bold mb-2">Something went wrong</h1>
            <p className="text-sm text-muted mb-6">
              {this.state.error?.message || 'An unexpected error occurred.'}
            </p>
            <button onClick={this.handleReload} className="btn-terminal">
              [ RELOAD ]
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
